<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="22">
        <table>
          <tr>
            <td colspan="6" style="text-align: center;">4.1.1 检测结果数据</td>
          </tr>
          <tr>
            <td>仪器名称</td>
            <td>接地电阻测试仪</td>
            <td>仪器编号</td>
            <td>{{ form.yqbh1 }}</td>
            <td>校准有效期</td>
            <td>{{ form.yqyxq1 }}</td>
          </tr>
          <tr>
            <td>仪器名称</td>
            <td>数字温湿度计</td>
            <td>仪器编号</td>
            <td>{{ form.yqbh2 }}</td>
            <td>校准有效期</td>
            <td>{{ form.yqyxq2 }}</td>
          </tr>
          <tr>
            <td>环境温度（℃）</td>
            <td>{{ form.hjwd }}</td>
            <td>环境湿度（%RH)</td>
            <td>{{ form.hjsd }}</td>
            <td>接地系统</td>
            <td>{{ form.jdxt }}</td>
          </tr>
          <tr>
            <td>序号</td>
            <td>被检测设备位置</td>
            <td>被检测设备名称</td>
            <td>实测阻值（Ω）</td>
            <td>检测结果</td>
            <td>备注</td>
          </tr>
          <template v-for="(row,i) in tableData">
            <tr :key="i">
              <td>{{ row.id }}</td>
              <td>{{ row.bjcsbwz }}</td>
              <td>{{ row.bjcsbmc }}</td>
              <td>{{ row.sczz }}</td>
              <td>{{ row.jcjg }}</td>
              <td>{{ row.remark }}</td>
            </tr>
          </template>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'report',
      form: {
        yqmc1: '',
        yqbh1: 'abc',
        yqyxq1: '',
        yqmc2: '',
        yqbh2: 'def',
        yqyxq2: '',
        hjwd: '',
        hjsd: '',
        jdxt: ''
      },
      tableData: []
    }
  },
  methods: {
    async getForm() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        let res = await this.$Api.get("record_cma_jddz1", {params: params});
        if (res) {
          this.form = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getList() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("record_cma_jddz", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getForm()
    this.getList()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
}

</style>

